import { __awaiter } from "tslib";
function loadPrintDependencies() {
    var _a, _b;
    // Resolve root workspace dependencies at runtime so this shared library can
    // compile without requiring them as package-local TypeScript dependencies.
    const html2canvasModule = require('html2canvas');
    const jspdfModule = require('jspdf');
    return {
        html2canvas: (_a = html2canvasModule.default) !== null && _a !== void 0 ? _a : html2canvasModule,
        JsPDF: (_b = jspdfModule.default) !== null && _b !== void 0 ? _b : jspdfModule,
    };
}
export const usePrint = () => {
    const downloadPdfFromDom = (contentRef, documentName) => __awaiter(void 0, void 0, void 0, function* () {
        const element = contentRef.current;
        if (!element)
            return;
        const { html2canvas, JsPDF } = loadPrintDependencies();
        const scale = 2;
        // Add a small height buffer so font descenders aren't clipped by html2canvas.
        // getBoundingClientRect reflects the CSS line-height box, which can sit above
        // the actual bottom of rendered glyphs.
        const descentBuffer = 8; // px — covers descenders at large font sizes
        const canvas = yield html2canvas(element, {
            scale,
            height: Math.ceil(element.getBoundingClientRect().height) + descentBuffer,
        });
        const image = canvas.toDataURL('image/png');
        // canvas dimensions are element pixels * scale.
        // Convert back to element pixels, then to mm (96dpi: 1px = 25.4/96 mm).
        // Math.ceil avoids jsPDF rounding the draw area fractionally smaller than the image.
        const PX_TO_MM = 25.4 / 96;
        const widthMm = Math.ceil((canvas.width / scale) * PX_TO_MM);
        const heightMm = Math.ceil((canvas.height / scale) * PX_TO_MM);
        // 0.5in margin on all sides (1in = 25.4mm)
        const marginMm = 0.5 * 25.4; // 12.7mm
        // A4 page, image drawn at its natural screen size with margin — no stretching
        const pdf = new JsPDF({
            orientation: 'portrait',
            format: 'a4',
            unit: 'mm',
        });
        pdf.addImage(image, 'PNG', marginMm, marginMm, widthMm, heightMm);
        pdf.save(`${documentName}.pdf`);
    });
    return { downloadPdfFromDom };
};
